import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CommonService } from '../../services/common.service';
import { SharedComponent } from '../../shared/shared';
import {FormGroup,FormControl,Validators,FormBuilder } from "@angular/forms";

/**
 * Generated class for the SupportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 @IonicPage()
 @Component({
 	selector: 'page-support',
 	templateUrl: 'support.html',
 })
 export class SupportPage {

 	supportForm = new FormGroup({
 		subject: new FormControl(),
 		description: new FormControl()
 	});

 	constructor(public navCtrl: NavController, public navParams: NavParams, public commonService :CommonService ,public sharedClass:SharedComponent,public fb : FormBuilder ,) {
 	}

 	ionViewDidLoad() {
 		console.log('ionViewDidLoad SupportPage');
 	}

 	ngOnInit() {

 		this.supportForm = this.fb.group({
 			subject: ['', Validators.compose([Validators.required, Validators.minLength(2)])],
 			description: ['', Validators.compose([Validators.required,Validators.minLength(60) ])]
 		});  
 	}


 	public sendMailToSupport(formValues) {

 		this.commonService.showLoading();

 		formValues.userId=(this.commonService.getLoggedInUserData())?this.commonService.getLoggedInUserData().userId:'';

 		this.commonService.sendMailToSupport(formValues).subscribe(success => {

 			this.commonService.dismisshowoading();
 			if (success && success.status=="success") {

 				// var loginUserData=this.commonService.getLoggedInUserData();
 				// loginUserData.fullName=formValues.firstName+" "+formValues.lastName;
 				// loginUserData.email=formValues.email;
 				// loginUserData.phoneNumber=formValues.phoneNumber;
 				// this.commonService.setLoggedInUserData(loginUserData);


 				this.commonService.showPopup("Success", "Your query sent successfully. You will get response to this query on your email.");


 			} else {

 				this.commonService.showPopup("Sorry", this.sharedClass.messages.ServerError);
 			}
 		});  
          /*,
        error => {
          this.commonService.dismisshowoading();
          console.log("ssssssssssss error",error);
          this.showPopup("Error server", error);
      });*/
  }

}



// WEBPACK FOOTER //
// ./src/pages/support/support.ts